import { ArrowUpRight, Check } from "lucide-react";

const SELL_FEATURES = [
  "Pallets estándar 1200x1000 mm",
  "Europallets 1200x800 mm",
  "Medidas especiales bajo pedido",
  "Madera seleccionada, reparada y certificada",
  "Resistencia para alta carga industrial",
];

const BUY_FEATURES = [
  "Pago competitivo según mercado",
  "Retiro a domicilio según volumen",
  "Descarga rápida de tu espacio físico",
  "Recupera capital de trabajo inmovilizado",
  "Coordinación logística directa",
];

export default function Services() {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="border-b-2 border-vp-yellow bg-vp-navy"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 lg:py-16 border-b-2 border-white/15">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-[2px] bg-vp-yellow" />
          <span className="label-industrial">02 · Servicios y soluciones</span>
        </div>
        <h2 className="heading-industrial text-4xl sm:text-5xl lg:text-6xl max-w-3xl text-white">
          Dos flujos. <span className="text-vp-yellow">Una solución</span>{" "}
          logística.
        </h2>
        <p className="mt-6 text-white/75 max-w-2xl text-lg">
          Si necesitas abastecerte de pallets o quieres liberar excedentes que
          ocupan tu bodega, en Vigopal cerramos la operación de extremo a
          extremo.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* SELL */}
        <div className="bg-vp-navy px-6 lg:px-12 py-12 lg:py-20 border-b-2 lg:border-b-0 lg:border-r-2 border-white/15">
          <div className="label-industrial mb-3">Venta · Para tu bodega</div>
          <h3 className="heading-industrial text-3xl lg:text-4xl mb-6 text-white">
            ¿Necesitas pallets?
          </h3>
          <p className="text-white/75 mb-8">
            Stock disponible para retiro o despacho directo. Clasificamos cada
            unidad por nivel de uso y resistencia antes de salir del patio.
          </p>
          <ul className="space-y-3 mb-10">
            {SELL_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-3">
                <Check
                  size={18}
                  className="text-vp-yellow mt-1 flex-shrink-0"
                  strokeWidth={3}
                />
                <span className="text-white/95 font-medium">{f}</span>
              </li>
            ))}
          </ul>
          <a
            href="#cotizar"
            data-testid="services-sell-cta"
            className="inline-flex items-center gap-3 bg-vp-yellow hover:bg-white text-[#001E62] font-bold uppercase tracking-widest text-xs px-6 py-4 transition-colors"
          >
            Ver stock disponible
            <ArrowUpRight size={16} />
          </a>
        </div>

        {/* BUY - inverted with red accent */}
        <div className="bg-vp-red text-white px-6 lg:px-12 py-12 lg:py-20 relative overflow-hidden">
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage:
                "linear-gradient(to right, rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.4) 1px, transparent 1px)",
              backgroundSize: "48px 48px",
            }}
          />
          <div className="relative">
            <div className="text-xs font-bold tracking-[0.18em] uppercase mb-3 text-white/80">
              Compra · Para tus excedentes
            </div>
            <h3 className="heading-industrial text-3xl lg:text-4xl mb-6">
              ¿Tienes stock sobrante?
            </h3>
            <p className="text-white/90 mb-8">
              Compramos tus pallets en desuso a precios competitivos del
              mercado. Liberamos tu metro cuadrado y convertimos madera en caja.
            </p>
            <ul className="space-y-3 mb-10">
              {BUY_FEATURES.map((f) => (
                <li key={f} className="flex items-start gap-3">
                  <Check
                    size={18}
                    className="text-vp-yellow mt-1 flex-shrink-0"
                    strokeWidth={3}
                  />
                  <span className="text-white font-medium">{f}</span>
                </li>
              ))}
            </ul>
            <a
              href="#cotizar"
              data-testid="services-buy-cta"
              className="inline-flex items-center gap-3 bg-vp-yellow hover:bg-white text-[#001E62] font-bold uppercase tracking-widest text-xs px-6 py-4 transition-colors"
            >
              Vender mis pallets
              <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
